<template>
  <footer
    class="footer-grey pt-12 px-[5%] lg:px-11 border-t-8 border-grey bg-black text-white text-lg"
  >
    <p class="text-base my-4 px-8 text-4xl text-center mb-10">
      Des questions?
      <a href="tel:+22899897164">Nous contacter au +22899897164</a>
    </p>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 text-[13px]">
      <ul class="px-5">
        <li class="text-lg"><a href="#!">Questions fréquentes</a></li>
        <li class="text-lg"><a href="#!">Contactez-nous</a></li>
        <li class="text-lg"><a href="#!">Informations administratives</a></li>
        <li class="text-lg"><a href="#!">Originaux d'Epiflix</a></li>
        <li class="text-lg"><a href="#!">Only on Netflix</a></li>
      </ul>
      <ul class="px-5">
        <li class="text-lg"><a href="#!">Centre d'Aide</a></li>
        <li class="text-lg"><a href="#!">Emplois</a></li>
        <li class="text-lg"><a href="#!">Termes et Conditions</a></li>
        <li class="text-lg"><a href="#!">Contacts</a></li>
      </ul>
      <ul class="px-5">
        <li class="text-lg"><a href="#!">Compte</a></li>
        <li class="text-lg"><a href="#!">Cartes Cadeaux</a></li>
        <li class="text-lg"><a href="#!">Confidentialité</a></li>
        <li class="text-lg"><a href="https://fast.com">Speed Test</a></li>
      </ul>
      <ul class="px-5">
        <li class="text-lg"><a href="#!">Espace Blog</a></li>
        <li class="text-lg"><a href="#!">Préférences de cookies</a></li>
        <li class="text-lg"><a href="#!">Mentions légales</a></li>
      </ul>
    </div>
    <p class="py-2 px-8 text-tiny text-sm">
      ©Copyright <a href="">Smart Coders Pro by Epitech </a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "FooterSection",
};
</script>
